module.exports = require('./helpers/bundle-url').getBundleURL('dZee7') + "logo.c51670a8.svg";